import { useNavigate } from 'react-router-dom';
import { ShieldAlert } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';

// 403 — Acceso denegado.
export const ForbiddenPage = () => {
  const navigate = useNavigate();

  const handleBack = (): void => {
    // Si no hay historial previo, volvemos a la home.
    if (window.history.length > 1) {
      navigate(-1);
    } else {
      navigate('/');
    }
  };

  return (
    <div className="bg-bg flex min-h-screen items-center justify-center p-6">
      <Card className="w-full max-w-md text-center">
        <CardHeader className="items-center gap-2">
          <div
            className="bg-surface-2 flex h-16 w-16 items-center justify-center rounded-full"
            aria-hidden="true"
          >
            <ShieldAlert className="text-warning h-8 w-8" />
          </div>
          <CardTitle className="text-2xl">403 — Acceso denegado</CardTitle>
          <CardDescription>
            No tienes permisos para ver esta página. Si crees que es un error, contacta a un
            administrador.
          </CardDescription>
        </CardHeader>
        <CardContent className="flex justify-center">
          <Button type="button" onClick={handleBack}>
            Volver
          </Button>
        </CardContent>
      </Card>
    </div>
  );
};
